export type NotificationSupport = NotificationPermission | "unsupported";

export const getNotificationSupport = (): NotificationSupport =>
  typeof window !== "undefined" && "Notification" in window
    ? Notification.permission
    : "unsupported";

export const requestNotificationPermission =
  async (): Promise<NotificationSupport> => {
    if (getNotificationSupport() === "unsupported") return "unsupported";
    return Notification.requestPermission();
  };

/**
 * Shows a system notification. Prefers the service worker registration (the
 * only option on Android and in the installed PWA) and falls back to the
 * Notification constructor. Never throws: a failed system notification must
 * not break the in-app toast.
 */
export async function showSystemNotification(
  title: string,
  options: NotificationOptions,
): Promise<void> {
  if (getNotificationSupport() !== "granted") return;
  try {
    const registration = await navigator.serviceWorker?.getRegistration();
    if (registration) {
      await registration.showNotification(title, options);
      return;
    }
    new Notification(title, options);
  } catch (error: unknown) {
    console.warn("Unable to show the system notification", error);
  }
}
